
<app-loading [loading]="showLoading"></app-loading>
  <div class="login-block" *ngIf="!showLoading">
    <div class="login-card" fxLayout="row" fxLayoutAlign="center center" style="height: 300px">
      <mat-icon style="width: 300px; height: 300px;font-size: 300px" [svgIcon]="'favicon'"></mat-icon>
    </div>
    <mat-card class="login-card">
      <mat-card-header>
        <mat-card-title fxLayoutAlign="start center">
          パスワードを更新してください
          <mat-icon style="color: #999999;font-size: 18px;width: 18px; height: 18px; margin: 0 .5em"
                    matTooltip="半角英字小文字、大文字、記号（バックスラッシュなど一部除く）が使えます"
                    matTooltipClass="custom-tooltip"
                    matTooltipPosition="above">info_outline</mat-icon>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form (ngSubmit)="submitLogin($event)"
              class="login-form"
              #loginForm="ngForm">

          <mat-form-field>
            <input matInput
              [type]="!show ? 'password' : 'text'"
              minlength="6"
              placeholder="パスワード（6文字以上）"
              id="inputPassword"
              [(ngModel)]="pass.password"
              name="password"
              #password="ngModel"
              [pattern]="usable"
              required>
            <mat-label class="form-error" color="danger"
                       *ngIf="password.dirty&&password.errors?.['required']">必須です
            </mat-label>
            <mat-label class="form-error" color="danger"
                       *ngIf="password.dirty&&password.errors?.['minlength']">6文字以上必要です
            </mat-label>
            <mat-label class="form-error" color="danger"
                       *ngIf="password.dirty&&password.errors?.['pattern']">
              {{commonService.unusableStringList(pass.password)}}は使用できません
            </mat-label>
            <button mat-icon-button
                    matSuffix type="button"
                    (click)="show = !show"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="show"
            >
              <mat-icon>{{show ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field>
            <input matInput
              [type]="!show ? 'password' : 'text'"
              minlength="6"
              placeholder="確認のためもう一度入力して下さい"
              id="inputPassword2"
              [(ngModel)]="pass.confirmpassword"
              name="confirmpassword"
              #confirmpassword="ngModel"
              required
              [pattern]="commonService.regexFy(pass.password)"
            >
            <mat-label class="form-error" color="danger"
                       *ngIf="confirmpassword.dirty&&confirmpassword.errors?.['required']">必須です
            </mat-label>
            <mat-label class="form-error" color="danger"
                       *ngIf="confirmpassword.dirty&&confirmpassword.errors?.['minlength']">6文字以上必要です
            </mat-label>
            <mat-label class="form-error" color="danger"
                       *ngIf="confirmpassword.dirty&&confirmpassword.errors?.['pattern']">一致しません
            </mat-label>
            <button mat-icon-button
                    matSuffix type="button"
                    (click)="show = !show"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="show"
            >
              <mat-icon>{{show ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>
          <br>
          <br>
          <button mat-button
            type="submit"
            color="primary"
            [disabled]="loginForm.invalid"
          >
            パスワードを更新
          </button>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
